/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export const SET_ACTIVE_COMPONENT = "SET_ACTIVE_COMPONENT";
export const SET_PREVIOUS_COMPONENT = "SET_PREVIOUS_COMPONENT";
export const SET_LAST_COMPONENT_SWATCH_APPLIED = "SET_LAST_COMPONENT_SWATCH_APPLIED";
export const CREATE_MENU_ITEM = "CREATE_MENU_ITEM";
export const CHANGE_MENU_ITEM_VISIBILITY = "CHANGE_MENU_ITEM_VISIBILITY";
export const UPDATE_MENU_ITEM_STATE = "UPDATE_MENU_ITEM_STATE";
export const CLEAR_MENU = "CLEAR_MENU";
